import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/species';

export class SpecieService extends RestServiceConnection {


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE ESPECIES
     * @EN GETS THE LIST OF SPECIES
     */
    // -------------------------------------------------------------------------------------------------------------
    listSpecies = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UNA ESPECIE POR SU ID
     * @EN GETS A SPECIE BY ITS ID
     * 
     * @param specieId
     */
    // -------------------------------------------------------------------------------------------------------------
    getSpecieById = async (specieId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { 
                id: 
                specieId
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UNA ESPECIE
     * @EN CREATES A SPECIE
     * 
     * @param specie
     */
    // -------------------------------------------------------------------------------------------------------------
    createSpecie = async (specie: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: specie,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ACTUALIZA UNA ESPECIE
     * @EN UPDATES A SPECIE
     * 
     * @param specie
     */
    // -------------------------------------------------------------------------------------------------------------
    updateSpecie = async (specie: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: specie,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UNA ESPECIE
     * @EN DELETES A SPECIE
     * 
     * @param id
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteSpecie = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { id },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIAS ESPECIES
     * @EN DELETES MULTIPLE SPECIES
     * 
     * @param ids
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiSpecie = async (ids: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multiple',
            data: { ids },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES IMPORTAR ESPECIES
     * @EN IMPORT SPECIES
     * 
     * @param file
     */
    // -------------------------------------------------------------------------------------------------------------
    importSpecies = async (formData: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/import',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

        // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE ESPECIES
     * @EN GETS THE LIST OF SPECIES
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}